import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Calendar } from "@/components/ui/calendar";

export default function CalendarPage() {
  const [date, setDate] = useState(new Date());
  const [fus, setFus] = useState([]);
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    api.get("/followups").then(r => setFus(r.data));
    api.get("/tasks").then(r => setTasks(r.data));
  }, []);

  const key = date?.toISOString().slice(0,10);
  const dayFus = fus.filter(f => f.next_date === key);
  const dayTasks = tasks.filter(t => t.due_date === key);

  return (
    <div className="space-y-6" data-testid="calendar-page">
      <div>
        <div className="overline text-muted-foreground mb-2">Schedule</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight leading-none">Calendar</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="p-6 lg:col-span-1">
          <Calendar mode="single" selected={date} onSelect={setDate} className="mx-auto" />
        </Card>
        <Card className="p-6 lg:col-span-2">
          <div className="overline text-muted-foreground mb-4">
            {date?.toLocaleDateString("en-IN", { weekday:'long', year:'numeric', month:'long', day:'numeric' })}
          </div>
          <div className="space-y-4">
            <div>
              <h3 className="font-heading font-bold text-lg mb-2">Follow-ups</h3>
              {dayFus.length ? dayFus.map(f => (
                <div key={f.id} className="p-3 rounded border border-border/40 mb-2 text-sm">
                  <div className="font-medium">{f.customer_name}</div>
                  <div className="text-xs text-muted-foreground">{f.channel} · {f.next_time}</div>
                </div>
              )) : <div className="text-xs text-muted-foreground">Nothing scheduled</div>}
            </div>
            <div>
              <h3 className="font-heading font-bold text-lg mb-2">Tasks Due</h3>
              {dayTasks.length ? dayTasks.map(t => (
                <div key={t.id} className="p-3 rounded border border-border/40 mb-2 text-sm">
                  <div className="font-medium">{t.title}</div>
                  <div className="text-xs text-muted-foreground">{t.assigned_to_name || "Unassigned"} · {t.priority}</div>
                </div>
              )) : <div className="text-xs text-muted-foreground">No tasks due</div>}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
